export class Impact {
  public safety: boolean;
  public quality: boolean;
  public availability: boolean;
  public productivity: boolean;

  public initImpactValue(impactConfig: any) {
    if (impactConfig) {
      this.safety = impactConfig.Safety;
      this.quality = impactConfig.Quality;
      this.availability = impactConfig.Availability;
      this.productivity = impactConfig.Productivity;
    }
  }

  public getImpactValue(propertyName: string): boolean {
    return this[propertyName.toLowerCase()];
  }

  public changeImpact(propertyName: string) {
    this[propertyName.toLowerCase()] = !this[propertyName.toLowerCase()];
  }

  public isAnyTrue() {
    return this.availability || this.productivity || this.quality || this.safety;
  }
}
